import { render, staticRenderFns } from "./AdminCompanyStatusBadge.vue?vue&type=template&id=16c3a4b0"
import script from "./AdminCompanyStatusBadge.vue?vue&type=script&lang=js"
export * from "./AdminCompanyStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c3a4b0')) {
      api.createRecord('16c3a4b0', component.options)
    } else {
      api.reload('16c3a4b0', component.options)
    }
    module.hot.accept("./AdminCompanyStatusBadge.vue?vue&type=template&id=16c3a4b0", function () {
      api.rerender('16c3a4b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminCompanyStatusBadge.vue"
export default component.exports